import AbstractRequest from '../AbstractRequest';
import { ApiMethod } from '../constants';
import {
  ApiResponseCheckIfFavorited,
  ApiResponseGetBusinessFavoriteCompanies,
} from '../types/business/businessCompany';

export class BusinessCompanyRequest extends AbstractRequest {
  get apiResource(): string {
    return 'business/company';
  }

  get dynamicIds(): Record<string, string> {
    return {
      id: '{id}',
    };
  }

  get routes(): Record<string, string> {
    return {
      GET_BUSINESS_FAVORITE_COMPANIES: `${this.apiRoute}/favorites`,
      CHECK_IF_FAVORITED: `${this.apiRoute}/${this.dynamicIds.id}/check-if-favorited`,
      FAVOURITE: `${this.apiRoute}/${this.dynamicIds.id}/favorite`,
      UNFAVOURITE: `${this.apiRoute}/${this.dynamicIds.id}/unfavorite`,
    };
  }

  async getBusinessFavoriteCompanies(queryOptions: {
    limit: number;
    offset: number;
  }): Promise<ApiResponseGetBusinessFavoriteCompanies> {
    const queryParams = [
      { key: 'limit', value: `${queryOptions.limit}` },
      { key: 'offset', value: `${queryOptions.offset}` },
    ];

    const result = await this.request(
      ApiMethod.GET,
      this.routes.GET_BUSINESS_FAVORITE_COMPANIES +
        this.buildQueryParams(queryParams)
    );

    return result.data;
  }

  async checkIfFavorited(id: string): Promise<ApiResponseCheckIfFavorited> {
    const result = await this.request(
      ApiMethod.GET,
      this.routes.CHECK_IF_FAVORITED!.replace(this.dynamicIds.id!, id)
    );

    return { isFavorited: result.data };
  }

  async favouriteBusinessCompany(id: string): Promise<void> {
    await this.request(
      ApiMethod.POST,
      this.routes.FAVOURITE!.replace(this.dynamicIds.id!, id)
    );
  }

  async unfavouriteBusinessCompany(id: string): Promise<void> {
    await this.request(
      ApiMethod.POST,
      this.routes.UNFAVOURITE!.replace(this.dynamicIds.id!, id)
    );
  }
}

export const businessCompanyRequest = new BusinessCompanyRequest();
